import { render, staticRenderFns } from "./OrderPaymentCard.vue?vue&type=template&id=ae22e740&"
import script from "./OrderPaymentCard.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports